import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { section5Validation } from "../../Constant/constant";
import Spinner from "../../Layouts/Spinner";
import {
  getSection5DataSingleId,
  updateSection5Data,
} from "../../../redux/cms/action";
import { getOssClient } from "../../Common/Utils/ossUtils";


const Section5Update = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [section3Image, Setsection1Image] = useState(null);
  const [imageLoading, setImageLoading] = useState(false);
  const section5Data = useSelector(
    (state) => state?.reusableSlice?.getSection5single
  );
  const [uploadProgress, setUploadProgress] = useState(0);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: section5Data?.title || "",
      description: section5Data?.description || "",
      sub_title: section5Data?.sub_title || "",
      ar_description: section5Data?.ar_description || "",
      ar_title: section5Data?.ar_title || "",
      ar_sub_title: section5Data?.ar_sub_title || "",
      image: section5Data?.image || "",
    },
    validationSchema: section5Validation,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  const handleSubmit = async (values) => {

    try {
      const data = {
        ...values,
        id: section5Data?.id,
        section: section5Data?.section,
        status: 1,
      };
      dispatch(updateSection5Data(data, setLoading, navigate));
    } catch (error) {
      console.error("Submit Error:", error);
    }
  };

  useEffect(() => {
    if (id) {
      dispatch(getSection5DataSingleId(id));
    }
  }, [id]);

  const handleLogoChange = async (event) => {
    const file = event.currentTarget.files[0];
      if (!file) return;
        try {
          setImageLoading(true)
          const ossClient = await getOssClient();
    
          const fileName = `images/${Date.now()}_${file.name}`;
    
          const result = await ossClient.put(fileName, file, {
            progress: (p) => {
              setUploadProgress(Math.round(p * 100));
            },
            mimeType: file.type,
          });
          formik.setFieldValue("image", result.url);
           setImageLoading(false)
        } catch (err) {
          console.error("Upload failed:", err);
        }
  };

  return (
    <div className="px-3">

      <div className=" category-wrapper">
        <form onSubmit={formik.handleSubmit}>
          <div className="d-flex justify-content-between align-items-center pb-5">
            <h3>Update Who for </h3>

          </div>

          <div className="box-shadowsec">
            <div className="business-logo d-flex align-items-center col-md-12 form-group justify-content-center flex-column pb-3">
              <div className="profile-edit">
                {imageLoading ? (
                  <div className="loader-container">
                    <i className="fa fa-spinner fa-spin loader-icon"></i>{" "}
                  </div>
                ) : (
                  <img src={formik.values.image} alt="Business Logo" />
                )}
                <div>
                  <label htmlFor="logo-upload" style={{ cursor: "pointer" }}>
                    <i className="fa fa-pencil"></i>
                  </label>
                  <p>Update Image</p>
                </div>
              </div>
              <div className="text-center">
                <input
                  type="file"
                  accept="image/*"
                  style={{ display: "none" }}
                  id="logo-upload"
                  onChange={handleLogoChange}
                />
              </div>
              {formik.touched.image && formik.errors.image ? (
                <div className="error">{formik.errors.image}</div>
              ) : null}
            </div>

            <div className="row  justify-content-between">
              <div className="col-md-12 form-group">
                <label>Title</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter title"
                  name="title"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.title}
                />
                {formik.touched.title && formik.errors.title ? (
                  <div className="error">{formik.errors.title}</div>
                ) : null}
              </div>
              <div className="col-md-12 form-group">
                <label>Ar Title</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter ar title"
                  name="ar_title"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.ar_title}
                />
                {formik.touched.ar_title && formik.errors.ar_title ? (
                  <div className="error">{formik.errors.ar_title}</div>
                ) : null}
              </div>
              <div className="col-md-12 form-group">
                <label>Sub Title</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter sub title"
                  name="sub_title"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.sub_title}
                />
                {formik.touched.sub_title && formik.errors.sub_title ? (
                  <div className="error">{formik.errors.sub_title}</div>
                ) : null}
              </div>
              <div className="col-md-12 form-group">
                <label>Ar Sub Title</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter ar sub title"
                  name="ar_sub_title"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.ar_sub_title}
                />
                {formik.touched.ar_sub_title && formik.errors.ar_sub_title ? (
                  <div className="error">{formik.errors.ar_sub_title}</div>
                ) : null}
              </div>
              <div className="col-md-12 form-group">
                <label>Description</label>
                <textarea
                  type="text"
                  className="form-control"
                  placeholder="Enter description"
                  name="description"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.description}
                />
                {formik.touched.description && formik.errors.description ? (
                  <div className="error">{formik.errors.description}</div>
                ) : null}
              </div>
              <div className="col-md-12 form-group">
                <label>Ar Description</label>
                <textarea
                  type="text"
                  className="form-control"
                  placeholder="Enter ar description"
                  name="ar_description"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.ar_description}
                />
                {formik.touched.ar_description && formik.errors.ar_description ? (
                  <div className="error">{formik.errors.ar_description}</div>
                ) : null}
              </div>
            </div>
          </div>
          <div
            className="d-flex align-items-center justify-content-center  "
            style={{ columnGap: "20px" }}
          >
            <button
              className="submit-btn   "
              style={{ width: "max-content" }}
              onClick={() => {
                navigate("/section5");
              }}
            >
              Back
            </button>
            <button
              className="submit-btn   "
              style={{ width: "max-content" }}
              type="submit"
            >
              {!loading ? "Update" : <Spinner />}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Section5Update;
